import { formatTitleForUrl } from '@/helpers'
import type { Collection, OtherTag, Tag } from '@setplex/tria-api'

export const createLabel = (x: Collection | Tag | OtherTag, link: string) => ({
  id: x.id,
  title: x.title || '',
  link: link + formatTitleForUrl(x.title || '') + x.id,
})

/**
 * Create label
 */
export const toLabel = (x: Collection | Tag, link: string) => ({
  id: x.id,
  title: x.title || '',
  link: link + formatTitleForUrl(x.title || '') + x.id,
})
